export default "__VITE_ASSET__Buqj4wAp__"